import React from 'react'
import { FooterStyled } from './Footer.styles'

const Footer = () => {
    return (
        <FooterStyled>
            <p>&copy; {new Date().getFullYear()} JasonShaw.Dev</p>
            <p></p>
        </FooterStyled>
    )
}

export default Footer
